/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { ImportErrorDto } from '../models/import-error-dto';
import { LoadResult } from '../models/load-result';
import { PlanningEvacuationDto } from '../models/planning-evacuation-dto';


/**
 * Fonctions de gestion des plannings d'évacuation
 */
@Injectable({
  providedIn: 'root',
})
export class PlanningsEvacuationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation planningEvacuationGetList
   */
  static readonly PlanningEvacuationGetListPath = '/api/plannings-evacuation/list';

  /**
   * Renvoie la liste des plannings d'évacuation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PlanningEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanningEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plannings d'évacuation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationGetList(params?: {
  }): Observable<Array<PlanningEvacuationDto>> {

    return this.planningEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PlanningEvacuationDto>>) => r.body as Array<PlanningEvacuationDto>)
    );
  }

  /**
   * Path part for operation planningEvacuationLoadList
   */
  static readonly PlanningEvacuationLoadListPath = '/api/plannings-evacuation/load-list';

  /**
   * Renvoie la liste des plannings d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plannings d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.planningEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation planningEvacuationGet
   */
  static readonly PlanningEvacuationGetPath = '/api/plannings-evacuation/{id}';

  /**
   * Renvoie le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationGet$Response(params: {

    /**
     * Identifiant du planning d&#x27;évacuation
     */
    id: number;
  }): Observable<StrictHttpResponse<PlanningEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanningEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationGet(params: {

    /**
     * Identifiant du planning d&#x27;évacuation
     */
    id: number;
  }): Observable<PlanningEvacuationDto> {

    return this.planningEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<PlanningEvacuationDto>) => r.body as PlanningEvacuationDto)
    );
  }

  /**
   * Path part for operation planningEvacuationPut
   */
  static readonly PlanningEvacuationPutPath = '/api/plannings-evacuation/{id}';

  /**
   * Met à jour le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationPut$Response(params: {

    /**
     * Identifiant du planning d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Planning d'évacuation
     */
    body: PlanningEvacuationDto
  }): Observable<StrictHttpResponse<PlanningEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanningEvacuationDto>;
      })
    );
  }

  /**
   * Met à jour le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationPut(params: {

    /**
     * Identifiant du planning d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Planning d'évacuation
     */
    body: PlanningEvacuationDto
  }): Observable<PlanningEvacuationDto> {

    return this.planningEvacuationPut$Response(params).pipe(
      map((r: StrictHttpResponse<PlanningEvacuationDto>) => r.body as PlanningEvacuationDto)
    );
  }

  /**
   * Path part for operation planningEvacuationDelete
   */
  static readonly PlanningEvacuationDeletePath = '/api/plannings-evacuation/{id}';

  /**
   * Supprime le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationDelete$Response(params: {

    /**
     * Identifiant du planning d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationDelete(params: {

    /**
     * Identifiant du planning d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.planningEvacuationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation planningEvacuationPost
   */
  static readonly PlanningEvacuationPostPath = '/api/plannings-evacuation';

  /**
   * Crée le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationPost$Response(params: {

    /**
     * Planning d'évacuation
     */
    body: PlanningEvacuationDto
  }): Observable<StrictHttpResponse<PlanningEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanningEvacuationDto>;
      })
    );
  }

  /**
   * Crée le planning d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningEvacuationPost(params: {

    /**
     * Planning d'évacuation
     */
    body: PlanningEvacuationDto
  }): Observable<PlanningEvacuationDto> {

    return this.planningEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<PlanningEvacuationDto>) => r.body as PlanningEvacuationDto)
    );
  }

  /**
   * Path part for operation planningEvacuationDownloadPlanning
   */
  static readonly PlanningEvacuationDownloadPlanningPath = '/api/plannings-evacuation/download';

  /**
   * Télécharge un modèle de fichier planning pour un futur upload.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationDownloadPlanning()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationDownloadPlanning$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationDownloadPlanningPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Télécharge un modèle de fichier planning pour un futur upload.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationDownloadPlanning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationDownloadPlanning(params?: {
  }): Observable<Blob> {

    return this.planningEvacuationDownloadPlanning$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation planningEvacuationUploadPlanning
   */
  static readonly PlanningEvacuationUploadPlanningPath = '/api/plannings-evacuation/upload';

  /**
   * Upload du fichier planning pour importer les évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationUploadPlanning()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationUploadPlanning$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ImportErrorDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationUploadPlanningPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportErrorDto>>;
      })
    );
  }

  /**
   * Upload du fichier planning pour importer les évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationUploadPlanning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationUploadPlanning(params?: {
  }): Observable<Array<ImportErrorDto>> {

    return this.planningEvacuationUploadPlanning$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportErrorDto>>) => r.body as Array<ImportErrorDto>)
    );
  }

  /**
   * Path part for operation planningEvacuationUploadPlanningFacture
   */
  static readonly PlanningEvacuationUploadPlanningFacturePath = '/api/plannings-evacuation/upload/facture';

  /**
   * Upload du fichier planning facture pour importer les évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationUploadPlanningFacture()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationUploadPlanningFacture$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ImportErrorDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationUploadPlanningFacturePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportErrorDto>>;
      })
    );
  }

  /**
   * Upload du fichier planning facture pour importer les évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationUploadPlanningFacture$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationUploadPlanningFacture(params?: {
  }): Observable<Array<ImportErrorDto>> {

    return this.planningEvacuationUploadPlanningFacture$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportErrorDto>>) => r.body as Array<ImportErrorDto>)
    );
  }

  /**
   * Path part for operation planningEvacuationExportPlanning
   */
  static readonly PlanningEvacuationExportPlanningPath = '/api/plannings-evacuation/export';

  /**
   * Télécharge l'export planning des évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningEvacuationExportPlanning()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationExportPlanning$Response(params?: {
    isFacture?: boolean;
    dispatchTransporteurId?: number;
    typeEvacuationId?: number;
    month?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PlanningsEvacuationService.PlanningEvacuationExportPlanningPath, 'get');
    if (params) {
      rb.query('isFacture', params.isFacture, {});
      rb.query('dispatchTransporteurId', params.dispatchTransporteurId, {});
      rb.query('typeEvacuationId', params.typeEvacuationId, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Télécharge l'export planning des évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `planningEvacuationExportPlanning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningEvacuationExportPlanning(params?: {
    isFacture?: boolean;
    dispatchTransporteurId?: number;
    typeEvacuationId?: number;
    month?: string;
  }): Observable<Blob> {

    return this.planningEvacuationExportPlanning$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
